<template>
    <div class="row carruselConContexto">
        <div class="contenedor-carrusel">
            <carrusel :autoplay="true" :responsive="{0:{items:1,nav:false},600:{items:2,nav:false},800:{items:3,nav:false},1200:{items:4,nav:false}}">
                <div v-for="contenidoDeLaPaginaWeb in seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb" v-bind:key="contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId">
                    <img v-bind:src="contenidoDeLaPaginaWeb.RutaDeImagen" /> 
                    <p class="text-center titulo" v-html="ConstruyeElContexto(contenidoDeLaPaginaWeb.TextoDelContenido)"></p>
                </div>
            </carrusel>
        </div>
    </div>
</template>

<script>
import carrusel from 'vue-owl-carousel'

export default {
    components: {
        carrusel
    },
    props: {
        seccionDeLaPaginaWeb: Object
    }, 
    methods: {
        ConstruyeElContexto: function(textoDelContenido){
            let nuevoTextoDelContenido = "";
            let listadoDeTextoSeparado = textoDelContenido.split('¶');

            listadoDeTextoSeparado.forEach(texto => {
                if(nuevoTextoDelContenido != "")
                    nuevoTextoDelContenido += "<br/>"
                
                nuevoTextoDelContenido += texto;
            });

            return nuevoTextoDelContenido;
        }
    }
}
</script>

<style scoped>
  .carruselConContexto .titulo{
    font-size: 1.6em;
  }

  .carruselConContexto .contenedor-carrusel {
    width: 100%;
  }

  p {
    font-weight: 500;
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Formatos/CarruselConContexto.vue